export default __webpack_public_path__ + "static/media/NanumSquareR.924c33f6.ttf";